module.exports = __webpack_public_path__ + "img/ic_tripadvisor-3.5.673fe4e8.svg";